<template>
    <div id="News" class="edrea_tm_section"> 
        <div class="team-members-container">
            <div v-for="member in teamMembers" :key="member.id" class="team-member-card">
                
                <div class="member-header">
                    <img :src="member.photo" :alt="member.name" class="member-photo">
                    <div>
                        <h3>{{ member.name }}</h3>
                        <h4>{{ member.title }}</h4>
                    </div>
                </div>
                
                <p class="member-description">{{ member.description }}</p>
                
                <div class="member-skills">
                    <span v-for="skill in member.skills" :key="skill" class="skill-tag">
                        {{ skill }}
                    </span>
                </div>
                
                <div class="member-separator"></div> 

            </div>
        </div>
    </div> </template>

<script>
export default {
    name: 'TeamComponent', // Added name for clarity
    data() {
        return {
            teamMembers: [
                {
                   id: 1,
                name: 'Furkan Ozturk', // Update the name to match the photo
                title: 'Project Manager/Software Developer', 
                // CRITICAL: Update the photo path to the exact filename:
                photo: '/img/news/furkan_ozturk.jpg', 
                description: 'Furkan Ozturk is a full-stack software developer and the founder of Oztech Creative, passionate about building modern websites and applications. He enjoys turning ideas into reliable, user-friendly digital solutions and working collaboratively with teams to deliver high-quality results.',
                skills: ['full-stack software developer', 'Project Manager', 'HTML','CSS','JavaScript','Java']
                
                },
                {
                    id: 2,
                    name: 'Muhammed Nuri Ozturk',
                    title: 'UI/UX & Graphic Designer',
                    photo: 'img/partners/nuri.jpg',
                    description: 'Muhammed Nuri is an experienced UI/UX and Graphic Designer with over 5 years of experience designing user-focused web and mobile interfaces. He combines strong visual design skills with usability principles to create intuitive, visually polished, and high-quality digital products.',
                    skills: ['Illustrator','Figma','Photoshop','After Effects','Premier Pro']
                    
                },
                  {
                    id: 3,
                    name: 'Mehmet Sarioz',
                    title: 'Full Stack Software Developer/ Software Tester',
                    photo: 'img/partners/Mehmet_Sarioz.jpeg',
                    description: 'Mehmet is a versatile software developer and software tester with a strong focus on building robust, maintainable applications and ensuring they meet high quality standards. He is experienced in analyzing requirements, writing clean and efficient code, and identifying potential issues through systematic testing. With a careful eye for detail and a problem solving mindset, Mehmet works to improve performance, reliability, and user experience across the software lifecycle.',
                    skills: ['HTML','CSS','JAVA','PYTHON','SQL','SELENIUM']
                    
                }
           
            ]
        };
    },
    // The component might have other exports or methods below this line
};
</script>


<style scoped>
/* The container now forces a vertical column */
.team-members-container {
    display: flex;
    flex-direction: column; /* This forces one member per row */
    align-items: center;    /* Centers the cards horizontally */
    gap: 50px;              /* Adds a large gap between members */
    padding: 40px 0;
    width: 100%;
}

/* The card now takes up a consistent width */
.team-member-card {
    width: 100%;
    max-width: 800px;       /* Keeps the text line-length readable on desktop */
    padding: 20px;
    box-sizing: border-box;
}

/* Header layout (Photo next to Name) */
.member-header {
    display: flex;
    align-items: center;
    gap: 25px;
    margin-bottom: 20px;
}

.member-photo {
    width: 200px;
    height: 200px;
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid var(--main-color); /* Uses your Pink theme color */
}

.member-description {
    line-height: 1.6;
    margin-bottom: 20px;
    font-size: 16px;
    background: rgba(53, 53, 53, 0.6); /* Black with 60% transparency */
    padding: 20px;                 /* Space between text and the box edge */
    border-radius: 10px;           /* Rounds the corners to match your buttons */
    line-height: 1.6;              /* Makes the text easier to read */
    backdrop-filter: blur(5px);    /* Optional: slightly blurs the dots behind it */
    color: #e4e4e4;                /* Ensures text remains crisp white */
}

/* Styling for the skills row */
.member-skills {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 15px;
}



/* Visual line between members */
.member-separator {
    width: 100%;
    height: 1px;
    background: rgba(255, 255, 255, 0.1);
    margin-top: 40px;
}

/* Mobile Tweak: On very small phones, stack the photo on top of the name */
@media (max-width: 480px) {
    .member-header {
        flex-direction: column;
        text-align: center;
    }
}
</style>